import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class PasswordResetService {
    private http = inject(HttpClient);
    private env = inject(envToken);

    private baseUrl: string;
    private userCountUrl: string;

    constructor() {
        this.baseUrl = `${this.env.apiUrl}/api/v1/password/reset`;
        this.userCountUrl = `${this.env.apiUrl}/api/v1/sso-user-details/enterprise`;
    }

    triggerPasswordReset(enterpriseId: number): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/enterprises/${enterpriseId}`, null);
    }

    triggerPasswordResetBatch(enterpriseIds: number[]): Observable<void> {
        return this.http.put<void>(`${this.baseUrl}/enterprises`, enterpriseIds);
    }

    getActiveUserCount(enterpriseId: number): Observable<number> {
        return this.http.get<number>(`${this.userCountUrl}/${enterpriseId}/count`);
    }

    getActiveUserCountBatch(enterpriseIds: number[]): Observable<number> {
        const params = new HttpParams().set('enterpriseIds', enterpriseIds.join(','));
        return this.http.get<number>(`${this.userCountUrl}/count`, { params });
    }
}
